export const DS_EM_ComponentSlides = require('./ds-expect-more').default;
export const KCDC_EM_ComponentSlides = require('./kcdc-expect-more').default;
export const SCS_EM_ComponentSlides = require('./scs-expect-more').default;
export const MCC_EM_ComponentSlides = require('./mcc-expect-more').default;

export default {
  DS_EM_ComponentSlides,
  MCC_EM_ComponentSlides,
  KCDC_EM_ComponentSlides,
  SCS_EM_ComponentSlides,
};



// WEBPACK FOOTER //
// ./src/presentations/expect-more/index.js